module.exports = __webpack_public_path__ + "img/1.9ab6bf3c.png";